import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { FormasAcessoService } from '../../../../../service/configuracao/forma-acesso.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: '[app-filtrar-formas-acesso]',
  templateUrl: 'filtro.component.html',
  styleUrls: ['./filtro.component.scss'],
})
export class FiltrarFormasAcessoComponent implements OnInit {
  searchForm: FormGroup;
  searchParams = {};
  errorMessage = '';
  searchInput: string = '';
  loading: boolean = false;
  filter: string = '';
  debounce: Subject<string> = new Subject<string>();

  constructor(
    private fb: FormBuilder,
    private formasACessoService: FormasAcessoService,
  ) {
    this.criarFormulario();
  }

  ngOnInit() {
    this.loading = true;
    this.formasACessoService
      .getformasAcesso({})
      .subscribe(
        res => this.loading = false,
        error => (this.errorMessage = error)
      );
    this.configurarSubject();
  }

  criarFormulario() {
    this.searchForm = this.fb.group({
      assunto: '',
    });
  }

  onSearchByTitle() {
    this.searchParams['descricao'] = this.searchInput;
    this.search();
  }

  search() {
    this.loading = true;
    this.formasACessoService
      .getformasAcesso(this.searchParams)
      .subscribe(res =>
        this.loading = false
      );
  }

  configurarSubject() {
    this.debounce
      .pipe(debounceTime(500))
      .subscribe(filter => {
        this.filter = filter;
        this.onSearchByTitle();
      });
  }
}
